module.exports = __webpack_public_path__ + "static/img/icon-search2.63af39b0.svg";